
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"data-name":"Camada 1","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 18.45 20.01"}, attrs),
              ...rest,
            },
            children.concat([_c('defs',[_c('clipPath',{attrs:{"id":"a","transform":"translate(-.78)"}},[_c('path',{attrs:{"fill":"none","d":"M0 0h20v20H0z"}})])]),_c('g',{attrs:{"data-name":"Grupo de máscara 1700"}},[_c('g',{attrs:{"data-name":"streamline-icon-soccer-player 20x20"}},[_c('g',{attrs:{"data-name":"Grupo 4181","clip-path":"url(#a)"}},[_c('path',{attrs:{"data-name":"Elipse 120","d":"M10.32 0A2.82 2.82 0 117.5 2.81 2.81 2.81 0 0110.32 0zm0 4.38a1.57 1.57 0 10-1.57-1.57 1.57 1.57 0 001.57 1.57z"}}),_c('path',{attrs:{"data-name":"Elipse 121","d":"M2.82 14.37A2.82 2.82 0 110 17.19a2.82 2.82 0 012.82-2.82zm0 4.38a1.57 1.57 0 10-1.6-1.56 1.56 1.56 0 001.6 1.56z"}}),_c('path',{attrs:{"data-name":"Caminho 3263","d":"M9.9 19.94a1.89 1.89 0 01-1.89-1.89 2.64 2.64 0 010-.29l.83-5.39a.63.63 0 011.24.19L9.27 18a.64.64 0 101.26.2l1.5-9.51a.63.63 0 01.62-.53h.51a3.07 3.07 0 002.78-1.72L17.1 4a.62.62 0 00-1.08-.6v.05L14.8 5.84a1.88 1.88 0 01-1.68 1H7.47a3.1 3.1 0 00-2.78 1.77L3.52 11a.622.622 0 001.11.56L5.81 9.2a1.88 1.88 0 011.68-1h.12a.63.63 0 01.61.59.38.38 0 010 .1l-1 6.21a.62.62 0 01-.72.51.61.61 0 01-.51-.71l.76-4.85-1 2a1.88 1.88 0 01-2.53.77 1.86 1.86 0 01-.79-2.38l1.14-2.39a4.32 4.32 0 013.89-2.42h5.66a.62.62 0 00.56-.35l1.18-2.35a1.873 1.873 0 013.42 1.53.61.61 0 01-.06.14l-1.16 2.34a4.32 4.32 0 01-3.84 2.42l-1.41 9a1.9 1.9 0 01-1.91 1.58z"}})])])])])
          )
        }
      }
    